import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// feature app-release
import * as A from './actions';
//////////////////////////////////////////////////

export const initialState = {
  version: {
    notes: [],
    release: '',
  },
};

const getAppReleaseSuccess = (state, data) => (
  P.$set('version', data, state)
);

const createAppReleaseSuccess = (state, data) => (
  P.$set('version', data, state)
);

const updateAppReleaseSuccess = (state, data) => (
  P.$set('version', data, state)
);

export default createReducer({
  [A.getAppReleaseSuccess]: getAppReleaseSuccess,
  [A.updateAppReleaseSuccess]: updateAppReleaseSuccess,
  [A.createAppReleaseSuccess]: createAppReleaseSuccess,
}, initialState);
